import { render, staticRenderFns } from "./ModalAdminCustomerClassroomEdit.vue?vue&type=template&id=4222e0e6&scoped=true&lang=pug&"
import script from "./ModalAdminCustomerClassroomEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminCustomerClassroomEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminCustomerClassroomEdit.vue?vue&type=style&index=0&id=4222e0e6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222e0e6",
  null
  
)

export default component.exports